import React from 'react';
import PropTypes from 'prop-types';
import Toolbar from '../../../../../../components/toolbar/Toolbar';

const RescoringToolbars = ({
    isCommonToolbar,
    isEndTimeToolbar,
    isInsertToolbar,
    corrections,
    toolbarConfiguration,
    audioDuration,
    setWordEvent,
    onKeyDownHandler,
    setEndWordData,
}) => {
    const { activeWordPosition, toolbarPosition, toolbarType, closeToolbar } = toolbarConfiguration;
    const commonToolbarProps = {
        corrections,
        activeWordPosition,
        toolbarPosition,
        toolbarType,
        closeToolbar,
        onEscHandler: onKeyDownHandler,
    };

    return (
        <>
            {isCommonToolbar && <Toolbar {...commonToolbarProps} setWordEvent={setWordEvent} />}
            {isEndTimeToolbar && (
                <Toolbar
                    {...commonToolbarProps}
                    toolbarTypeClassName="end-time-toolbar"
                    audioDuration={audioDuration}
                    setEndWordData={setEndWordData}
                />
            )}
            {isInsertToolbar && <Toolbar {...commonToolbarProps} setWordEvent={setWordEvent} />}
        </>
    );
};

RescoringToolbars.defaultProps = {
    isCommonToolbar: false,
    isEndTimeToolbar: false,
    isInsertToolbar: false,
    toolbarConfiguration: {},
    corrections: [],
    audioDuration: null,
    setWordEvent: () => {},
    onKeyDownHandler: () => {},
    setEndWordData: () => {},
};

RescoringToolbars.propTypes = {
    isCommonToolbar: PropTypes.bool,
    isEndTimeToolbar: PropTypes.bool,
    isInsertToolbar: PropTypes.bool,
    toolbarConfiguration: PropTypes.object,
    corrections: PropTypes.array,
    audioDuration: PropTypes.number,
    setWordEvent: PropTypes.func,
    onKeyDownHandler: PropTypes.func,
    setEndWordData: PropTypes.func,
};

export default RescoringToolbars;
